var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoalConfigureApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_185_4213)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 150,
    height: 150,
    rx: 38,
    fill: "#CurrentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 150,
    height: 150,
    rx: 38,
    stroke: "url(#paint0_linear_185_4213)",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_185_4213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5 92.5005H40V103C40 105.387 40.9482 107.676 42.636 109.364C44.3239 111.052 46.6131 112 49 112H59.5V92.5005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 92.5005H92.5V112H103C105.387 112 107.676 111.052 109.364 109.364C111.052 107.676 112 105.387 112 103V92.5005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5 66.2485H40V85.7482H59.5V66.2485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 66.2485H92.5V85.7482H112V66.2485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5 40H49C46.6131 40 44.3239 40.9482 42.636 42.636C40.9482 44.3238 40 46.613 40 48.9999V59.4997H59.5V40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.75 92.5005H66.25V112H85.75V92.5005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.75 66.2485H66.25V85.7482H85.75V66.2485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.75 40H66.25V59.4997H85.75V40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 40H92.5V59.4997H112V48.9999C112 46.613 111.052 44.3238 109.364 42.636C107.676 40.9482 105.387 40 103 40Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_185_4213",
    x: -24,
    y: -24,
    width: 200,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_185_4213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_185_4213",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_185_4213",
    x: 40,
    y: 40,
    width: 72,
    height: 76.0002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_185_4213"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_185_4213",
    x1: 76,
    y1: 1,
    x2: 76,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalConfigureApps);
export default __webpack_public_path__ + "static/media/Goal-Configure-Apps.3d927a3041004c2e29f9f438f569442f.svg";
export { ForwardRef as ReactComponent };